export const ADD_ORG_NOTES_MODAL_NAME = 'ADD_ORG_NOTES_MODAL_NAME';
